import { InstallCoach } from "./InstallCoach";
import { useServiceWorkerUpdate } from "./useServiceWorkerUpdate";

// Single mount point for PWA runtime concerns: arms update-on-navigation and
// renders the iOS install coach. Must live inside the Router.
export function PwaRuntime() {
  useServiceWorkerUpdate();
  return <InstallCoach />;
}
